
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gqzYY5Uzqps3dEpIx_sgHQRp2tebsSqewI5JSbQJkJv8Meta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexrcyN2Kro8p9CAOq9Og4yh1nEIQC56oyZ7oS8go6ALS0Meta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchwszf61Wqi0OZNWmREbTMI0T4CUfyPLyrGOfgb66rVB4Meta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexrVNaQXiEVnDZ6mCfyWILJKbBj_45nAUts_LVPJb7HraPYMeta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93q_5GhddG0m_0Jz0YWPRmHFRB20p6UhutPbSnTRpaWAMMeta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexo7Yo_GBY_Af5U6fS2_45na5IFDgCLL3iq_iXDPMpXHGvsMeta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Qr3q_45VSHIe0J48JJoElYNSuaK1kFG8ABFqPykZyYiocMeta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index9Y9YlLbxiMN0OkbCaiEwYRaD934QIC4uYJ5bBNWDsy0Meta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93IvoJgYOtnU9tFc5f_MRQ9HjCyKim0s2XD6P_45B7xELYoMeta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexmIn44EuarxI_45OHOggUO1o4aL6kY2J6IIL_VCp8rUD7cMeta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexmTxXmM2t7zDpiSsE8UPGsKrS3qTtpozo9SFDhiRpaHYMeta } from "/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexo7Yo_GBY_Af5U6fS2_45na5IFDgCLL3iq_iXDPMpXHGvsMeta || {},
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index9Y9YlLbxiMN0OkbCaiEwYRaD934QIC4uYJ5bBNWDsy0Meta || {},
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexmIn44EuarxI_45OHOggUO1o4aL6kY2J6IIL_VCp8rUD7cMeta || {},
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexmTxXmM2t7zDpiSsE8UPGsKrS3qTtpozo9SFDhiRpaHYMeta || {},
    component: () => import("/codebuild/output/src161127147/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]